interface GameImage {
  hor: any,
  blurHash: string
}

export function gameSet(games: Array<any>, setName: string): Array<any> {
  return games.find(gameSet => gameSet.name === setName)?.games
}

const defaultBlurHash = 'ULFjM;iv01yE?^IBMx.9EmS1i_jKV|xtk8S3'

export function gameImage(game: any, locale: string): GameImage {
  const gameImage = game.image[locale]
  return {
    ...gameImage,
    blurHash: gameImage.blurHash || defaultBlurHash
  }
}